import { useState } from 'react';

import Icon from '../../../../../app/shared/components/Icon/Icon';
import { Sheet, SheetTrigger } from '../../../../../app/shared/components/Sheet/Sheet';
import StoreFlag from '../../../StoreFlag';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import StoreAndLanguageSelectorState from '../StoreAndLanguageSelectorState';
import StoreSelector from '../StoreSelector/StoreSelector';
import css from './StoreAndLanguageSelectorSheet.css';

interface StoreAndLanguageSelectorSheetProps {
  state: StoreAndLanguageSelectorState;
}

export default function StoreAndLanguageSelectorSheetProps({ state }: StoreAndLanguageSelectorSheetProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <SheetTrigger
        className={css.trigger}
        onOpenChange={setIsOpen}
        aria-label={state.translation.openButton.interpolate([
          ['currentStore', state.currentStore.displayName],
          ['currentLanguage', state.currentLanguage.displayName],
        ])}
      >
        <StoreFlag className={css.flag} storeId={state.currentStore.id} />
        <span className={css.text} aria-hidden="true">
          <span>{state.currentStore.countryCode}</span>|<span>{state.currentLanguage.code}</span>
        </span>
        <Icon className={css.icon} name="angleDown" />
      </SheetTrigger>
      <Sheet
        className={css.content}
        title={state.translation.title}
        closeButtonLabel={state.translation.closeButton}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
      >
        <LanguageSelector
          items={state.currentStoreLanguages}
          selectedItem={state.currentLanguage}
          translation={state.translation.languageSelector}
          onSelect={state.selectLanguage}
        />
        <StoreSelector
          currentStoreKey={state.currentStore.key}
          items={state.stores}
          translation={state.translation.storeSelector}
          onSelect={state.selectStore}
        />
      </Sheet>
    </>
  );
}
